// The buyer portal preview shows only the page's yellow ribbon, so forms hide their own preview badge there.
export const formBadgeHidden = () =>
  typeof window !== "undefined" && new URLSearchParams(window.location.search).get("badge") === "0";
